export default __webpack_public_path__ + "0b01a2970224421b6111e554506dba7d.png";